import React, { useEffect, useState } from "react";
import classes from "../Navbar/Navbar.module.css";
import { useNavigate } from "react-router-dom";
const Navbar = () => {
  const [shownav, setShowNav] = useState(false);
  const navigate = useNavigate();
  const transitionNavbar = () => {
    if (window.scrollY > 100) {
      setShowNav(true);
    } else {
      setShowNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", transitionNavbar);
    // cleanup function
    return () => window.removeEventListener("scroll", transitionNavbar);
  }, []);

  return (
    <div>
      <div className={`${classes.nav}  ${shownav && classes.nav_black}`}>
        <div className={classes.nav_content}>
          <img
            onClick={() => navigate("/")}
            className={classes.img_logo}
            src="https://1000logos.net/wp-content/uploads/2017/05/Netflix-Logo.png"
            alt="Netlfix logo"
          ></img>

          <img
            onClick={() => navigate("/profile")}
            className={classes.avatar_logo}
            src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png"
            alt="Avatar"
          ></img>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
